import * as React from "react"
import { Box, Text } from "@indeed/ifl-components"
import { StyleProps } from "@indeed/ifl-components/src/utils/styled"
import { SortDescending } from "@indeed/ifl-icons"

interface DislikePreferencesHeaderProps extends StyleProps {
    headerText: string
    headerId?: string
}
export const DislikePreferencesHeader: React.FC<DislikePreferencesHeaderProps> = (props: DislikePreferencesHeaderProps) => {
    const { headerText, sx, headerId } = props

    return (
        <Box sx={{ display: "flex", placeContent: "center space-between", maxInlineSize: "50rem", ...sx }}>
            <Box
                sx={{
                    marginBlockEnd: "auto",
                    marginBlockStart: "auto",
                    marginInlineEnd: "auto",
                    marginInlineStart: "auto",
                    backgroundColor: "background.status.warning",
                    color: "foreground.inverse",
                    borderRadius: "full",
                    inlineSize: "2rem",
                    minInlineSize: "2rem",
                    paddingBlockEnd: 2,
                    paddingBlockStart: 2,
                    paddingInlineEnd: 2,
                    paddingInlineStart: 2,
                    blockSize: "2rem",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
                aria-hidden
            >
                <SortDescending aria-hidden />
            </Box>
            <Text level={[2, 3]} sx={{ marginInlineStart: 4, marginBlockEnd: 0, marginBlockStart: 0 }} variant="secondary" id={headerId}>
                {headerText}
            </Text>
        </Box>
    )
}
